import { useCallback } from 'react';
import type { ListData, SearchParams } from 'framework/list';
import { applications } from '../mockData';
import type { ApplicationRow } from '../shared/types';

const useApplicationsService = () => {
  const search = useCallback(
    async (params: SearchParams & { pageNumber?: number } = {}): Promise<ListData<ApplicationRow>> => {
      const totalElements = applications.length;
      const pageSize = params.pageSize ?? (totalElements || 1);
      const pageNumber = params.pageNumber ?? 0;
      const startIndex = pageNumber * pageSize;

      return {
        result: applications.slice(startIndex, startIndex + pageSize),
        totalPages: Math.max(Math.ceil(totalElements / pageSize), 1),
        totalElements,
      };
    },
    [],
  );

  return { search };
};

export default useApplicationsService;
